<template>
    <tr class="table-sub-row level-3-row" :class="{ 'sub-asset-row': parentAsset }">
        <td class="clickable" @click="toggle">
            <div class="d-flex align-items-center">
                <div class="order-item-thumbnail mr-3">
                    <!--                    <t-img-->
                    <!--                        v-if="orderAsset.asset_image"-->
                    <!--                        :src="orderAsset.asset_image"-->
                    <!--                        height="50"-->
                    <!--                        width="50"-->
                    <!--                    ></t-img>-->
                    <!--                    <div v-else class="placeholder-thumb"></div>-->
                </div>
            </div>
        </td>
        <td class="clickable" @click="toggle">
            <div class="d-flex align-items-center">
                <status-icon :status="orderAsset.status" :normalized-status="orderAsset.normalized_status" />
                <div class="ml-2">
                    <div class="font-weight-bold">{{ orderAsset.name }}</div>
                    <small v-if="orderAsset.is_bundle" class="text-muted">Bundle</small>
                </div>
            </div>
        </td>
        <td class="clickable" @click="toggle">
            <!-- Items count is in order_items array length -->
            {{ orderAsset.order_items ? orderAsset.order_items.length : 0 }}
        </td>
        <td class="clickable" @click="toggle">
            <run-dates :start="orderAsset.start_date" :end="orderAsset.end_date"></run-dates>
        </td>
        <td class="clickable" @click="toggle">
            {{ orderAsset.units }}
        </td>
        <td class="clickable" @click="toggle">
            {{ orderAsset.total_formatted }}
        </td>
        <td v-if="_isAdmin">
            <!-- Payment status for asset level is usually empty -->
        </td>
        <td colspan="2">
            <div v-if="!disableActions" class="d-flex justify-content-end align-items-center">
                <!-- Review Button -->
                <button
                    v-if="orderAsset.can && orderAsset.can.review"
                    class="btn btn-sm mr-1 btn-primary"
                    @click.stop="openReview"
                >
                    Review {{ orderAsset.is_bundle ? 'Bundle' : 'Asset' }}
                </button>

                <!-- Download/Share (when can't review) -->
                <template v-else>
                    <download-order-items download-type="order-items" :query="{ filter: { id: orderAsset.order_item_ids } }"></download-order-items>
                    <share-order-items share-type="order-items" :query="{ filter: { id: orderAsset.order_item_ids } }"></share-order-items>
                </template>

                <!-- Verify Items Dropdown -->
                <div
                    v-if="orderAsset.can && orderAsset.can.verify_items && !parentAsset"
                    class="btn-group"
                    role="group"
                    title="Confirm this asset has been Fulfilled"
                    v-b-tooltip.hover
                >
                    <button type="button" class="btn btn-sm dropdown-toggle btn-secondary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{ verifyButtonLabel }}
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="#" @click.prevent="setItemStatus('fulfilled')"> Fulfilled </a>
                        <a class="dropdown-item" href="#" @click.prevent="setItemStatus('unfulfilled')"> Unfulfilled </a>
                    </div>
                </div>

                <!-- Set Paid Dropdown -->
                <div v-if="orderAsset.can && orderAsset.can.set_paid && orderAsset.status !== 'unfulfilled'" class="btn-group" role="group">
                    <button type="button" class="btn btn-sm dropdown-toggle btn-primary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click.stop>
                        {{ paidButtonLabel }}
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="#" @click.prevent="setItemStatus('paid')"> Mark Paid </a>
                        <a class="dropdown-item" href="#" @click.prevent="setItemStatus('fulfilled')"> Mark Unpaid </a>
                    </div>
                </div>

                <!-- Reorder Button (Advertisers only) -->
                <a v-if="canReorder" class="btn btn-sm btn-success text-white" :href="'/advertiser/assets/' + orderAsset.asset_id" @click.stop> REORDER </a>

                <!-- Expand/Collapse Icon -->
                <button class="btn btn-link p-0 ml-2" @click.stop="toggle">
                    <i :class="isExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                </button>
            </div>
        </td>
    </tr>
</template>

<script>
import StatusIcon from './partials/StatusIcon.vue';

export default {
    name: 'OrdersTableOrderAsset',

    components: {
        StatusIcon,
    },

    props: {
        order: {
            type: Object,
            required: true,
        },
        orderAsset: {
            type: Object,
            required: true,
        },
        parentAsset: {
            type: Object,
            default: null,
        },
        disableActions: {
            type: Boolean,
            default: false,
        },
        toggleKey: {
            type: String,
            required: true,
        },
        expandedKeys: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        isExpanded() {
            return this.expandedKeys.includes(this.toggleKey);
        },

        verifyButtonLabel() {
            if (this.orderAsset.all_unfulfilled) {
                return 'Unfulfilled';
            }
            if (this.orderAsset.all_fulfilled) {
                return 'Fulfilled';
            }
            return 'Verify ' + (this.orderAsset.is_bundle ? 'Bundle' : 'Asset');
        },

        paidButtonLabel() {
            if (this.orderAsset.all_paid) {
                return 'Paid';
            }
            return 'Unpaid';
        },

        canReorder() {
            return (
                this._isAdvertiser &&
                !this.orderAsset.is_bundled &&
                this.order.status &&
                this.order.status.includes('Complete') &&
                this.orderAsset.can &&
                this.orderAsset.can.reorder
            );
        },
    },

    methods: {
        toggle() {
            this.$emit('toggle', this.toggleKey);
        },

        openReview() {
            this.$emit('open-review', this.orderAsset.creative_ids, this.order.id, false);
        },

        setItemStatus(status) {
            this.$emit('update-item-status', this.orderAsset.order_item_ids, status);
        },
    },
};
</script>

<style scoped>
.clickable {
    cursor: pointer;
}

.sub-asset-row {
    background-color: #f8f9fa;
}

.order-item-thumbnail {
    width: 50px;
    height: 50px;
    overflow: hidden;
}

.placeholder-thumb {
    width: 50px;
    height: 50px;
    background-color: #e9ecef;
    border-radius: 4px;
}
</style>
